import { useAuth } from "@assetwatch/auth";
import { useQuery } from "@tanstack/react-query";
import { isInternalEnterpriseUser } from "../lib/enterpriseAccess";
import { selectableCustomersQueryOptions } from "../queries/useGetCustomerOptions";

export function useResolvedEnterpriseCustomer(
  currentExternalCustomerId: string | undefined,
) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const isInternalUser = isInternalEnterpriseUser(user);
  const selectableCustomersQuery = useQuery({
    ...selectableCustomersQueryOptions(),
    enabled: !isLoading && isAuthenticated,
  });

  const autoResolvedExternalCustomerId =
    !isInternalUser && selectableCustomersQuery.data?.length === 1
      ? selectableCustomersQuery.data[0].externalCustomerId
      : undefined;
  const resolvedExternalCustomerId =
    currentExternalCustomerId ?? autoResolvedExternalCustomerId;
  const isResolvingExternalCustomer =
    !isInternalUser &&
    !currentExternalCustomerId &&
    selectableCustomersQuery.isLoading;
  const hasResolvedExternalCustomer =
    !isInternalUser && Boolean(resolvedExternalCustomerId);
  const hasCustomerResolutionError =
    !isInternalUser &&
    selectableCustomersQuery.isFetched &&
    !resolvedExternalCustomerId;

  return {
    isInternalUser,
    selectableCustomers: selectableCustomersQuery.data ?? [],
    isLoadingSelectableCustomers: selectableCustomersQuery.isLoading,
    resolvedExternalCustomerId,
    isResolvingExternalCustomer,
    hasResolvedExternalCustomer,
    hasCustomerResolutionError,
  };
}
